import { useEffect, useMemo, useState } from 'react'
import { Link } from "react-router-dom"
import { Table, Space, Button, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from '../../component/common/Selects'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table

type pagination = {
  current: number,
  pageSize: number,
  total: number,
}

type fetchParams = {
  date: any,
  store_id: undefined | string
}

export default function CkConsumeList() {

  let otherParamsTml = {
    date: null,
    store_id: undefined
  }

  let paginatioTml = {
    current: 1,
    pageSize: 8,
    total: 0
  }

  const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
  const [pagination, setPagination] = useState<pagination>(paginatioTml)

  const [tableList, setTableList] = useState<any[]>([])

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    fetch({ pagination, otherParams })
  }, [pagination.current])

  const handleSelectChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleChange = (value: any, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSearch = () => {
    fetch({ pagination, otherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current

    setPagination(p)
  }

  const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }

    axiosTable.get('/chankang_center/data_report/month/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setTableList(response.records)
      }
    })
  }

  const exportExcel = () => {
    const iPagination: any = { ...pagination }
    let params: any = { ...otherParams }

    baseAxiosComplete('/chankang_center/data_report/month/export', {
      params: {
        ...iPagination,
        ...params
      }

    }).then(res => {
      if (res.status === 0) {
        window.open(res.data)
      }
    })
  }

  const resetForm = () => {
    setOtherParams(otherParamsTml)

    let p: any = { ...pagination }
    p.current = 1

    setPagination(p)
    fetch({ pagination: p, otherParams: otherParamsTml })
  }

  return <div className="common-page">
    {/* 产康中心 -> 产康数据报表 -> 产康月度报表 */}
    <BreadCrumb position={['产康数据报表', '产康月度报表']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <DatePicker style={{ marginRight: 8, marginBottom: 12 }} placeholder={'选择日期'} picker="month" value={otherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleSelectChange(value, 'store_id') }} />
        </div>
      </Space>

      <div style={{ marginTop: 10 }}>
        <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>
      </div>
    </div>

    <div className="common-main">
      <Table dataSource={tableList} scroll={{ x: 'max-content' }} bordered={true} rowKey="consume_id" pagination={pagination} onChange={handleTableChange}>
        {/* <Column
          title="操作"
          key="action"
          render={(text, record: any) => (
            <Space size="middle">
              <Button type="primary" ><Link to={"/check_in_income_detail/" + record.report_check_in_id}>查看</Link></Button>
            </Space>
          )}
        /> */}

        <Column title="日期" dataIndex="date" key="date" />
        <Column title="门店" dataIndex="store_name" key="store_name" />
        <Column title="目前在住人数" dataIndex="current_stay_num" key="current_stay_num" />
        <Column title="上月遗留人数" dataIndex="last_month_remain_num" key="last_month_remain_num" />
        <Column title="当月新客转化人数" dataIndex="new_customer_convert_num" key="new_customer_convert_num" />
        <Column title="新客转化率" dataIndex="new_customer_convert_rate" key="new_customer_convert_rate" />
        <Column title="新客业绩" dataIndex="new_customer_performance" key="new_customer_performance" />
        <Column title="当月老客转化人数" dataIndex="old_customer_convert_num" key="old_customer_convert_num" />
        <Column title="老客转化率" dataIndex="old_customer_convert_rate" key="old_customer_convert_rate" />
        <Column title="老客业绩" dataIndex="old_customer_performance" key="old_customer_performance" />
        <Column title="老客回店人数" dataIndex="old_customer_return_num" key="old_customer_return_num" />
        <Column title="老客回店率" dataIndex="old_customer_return_rate" key="old_customer_return_rate" />
        <Column title="今月业绩" dataIndex="current_month_performance" key="current_month_performance" />
        <Column title="目前总业绩" dataIndex="total_performance" key="total_performance" />
        <Column title="目标业绩" dataIndex="target_performance" key="target_performance" />
        <Column title="目标达成率" dataIndex="target_achieve_rate" key="target_achieve_rate" />
        <Column title="客单价" dataIndex="guest_unit_price" key="guest_unit_price" />
      </Table>
    </div>
  </div>
}